import {useEffect } from "react";
import { Link } from 'react-router-dom';
import { useLayoutLanguage } from '../context/LayoutLanguageContext';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import Logo from '../assets/images/hugo-logo.svg';
import Modal from '../components/Modal';
import useModal from '../hooks/useModal';
import HamburgerMenu from '../components/HamburgerMenu';
import { useAppNavigation } from "../hooks/useAppNavigation";
import { useProductLanguage } from "../context/ProductLanguageContext";
import packageJson from '../../package.json';
import { isDebugMode } from '../utils/utils';


const Layout = ({ children }) => {
  const { layoutLanguage, changeLayoutLanguage, layoutT } = useLayoutLanguage();
  const { t: productT } = useProductLanguage();

  const { goToApplications, isApplications, isProduct, isLogin } = useAppNavigation();

  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  // Toggle language function
  const toggleLanguage = () => {
    const newLanguage = layoutLanguage === 'English' ? 'Français' : 'English';
    changeLayoutLanguage(newLanguage);
  };

  // Handle logout

  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin, 
    }).catch(e => {
      console.error("Logout error:", e);
    });
  };

  const account = instance.getAllAccounts()[0];
  const advisorName = account?.idTokenClaims?.name || '';

  const { isModalVisible, modalContent, openModal, closeModal } = useModal();

  const handleLinkClick = (e) => {    
    if (e) e.preventDefault(); 
    openModal(
      productT('confirmation'),
      productT('confirmation_text')
    );
  };    


  useEffect(() => {
  const handleBackButton = () => {
    // Prevent actual back navigation
    window.history.pushState(null, '', window.location.href);

    if (isProduct) {
      handleLinkClick(); 
    } else if (isApplications) {
    } else {
    }
  };

  // Initial push to block the first back
  window.history.pushState(null, '', window.location.href);
  window.addEventListener('popstate', handleBackButton);

  return () => {
    window.removeEventListener('popstate', handleBackButton);
  };
}, [isProduct, isApplications]);


  const externalLink = "https://www.humania.ca/conseillers/produits-et-plateformes-de-ventes/hugo-vie/";

  const handleInfo = () => {
    window.open(externalLink, '_blank');
  };

  return (
    <>
      <header {...(isProduct && { className: 'product-page' })}>

        <div className='header-boxed'>

          {(isApplications || isProduct) && <div className="welcome-advisor-mobile mobile">
            <span>{layoutT('welcome')}, {advisorName}</span></div>
          }
          <div className="col d-flex align-items-center justify-content-start">
            <div className="logo"

              tabIndex='0'

              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault(); // Prevent scrolling
                  goToApplications();
                }
              }}
            >
              <Link to={'/'}>
                <img src={Logo} className="img-responsive logo-img" alt="Logo" width={159} height={26} />
              </Link>
            </div>
            {(isApplications || isProduct) && <div className="welcome-advisor desktop" tabIndex='-1'><span>{layoutT('welcome')},</span>  <span id="advisorName">{advisorName}</span></div>}

          </div>

          <div className="col d-flex align-items-center justify-content-end" tabIndex='-1'>
            {isProduct && (
              <div className="applications-menu hide-on-mobile">
                <div className="need-information">
                  <a href="#" onClick={(e) => { e.preventDefault(); handleInfo(); }}>
                    {layoutT('need_information')}
                  </a>
                </div>

                <div className="suspend-application">
                  <Link to="#" onClick={(e) => { e.preventDefault(); handleLinkClick(); }}>
                    {layoutT('suspend_application')}
                  </Link>

                </div>
              </div>
            )}

            {(!isProduct) &&
              <span
                className="header-language"
                onClick={toggleLanguage}

                tabIndex='0'

                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault(); // Prevent scrolling

                    toggleLanguage();
                  }
                }}
              >
                  {layoutLanguage === 'English' ? 'FR' : 'EN'}
              </span>}

            {isAuthenticated &&
              (
                <span
                  onClick={handleLogout}
                  className='log-out hide-on-mobile'

                  tabIndex='0'

                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault(); // Prevent scrolling

                      handleLogout();
                    }
                  }}
                >
                  <i className="fa fa-door-open header-language"></i>

                  {layoutT('disconnect')}

                </span>
              )
            }
          </div>

          <HamburgerMenu />

        </div>

      </header>
      <main>
        <div className='main-boxed'>
          {children}
        </div>
      </main>


      <Modal
        isVisible={isModalVisible}
        title={modalContent.title}
        content={modalContent.content}
        onClose={closeModal}
        actions={
          <>
            <button onClick={() => {
              goToApplications();
              closeModal();
            }} className="btn-purple">
              {productT('yes')}
            </button>
            <button onClick={closeModal} className="btn-purple">
              {productT('no')}
            </button>
          </>
        }
      />

      {isLogin && (
        <div className="wave">
          <svg viewBox="0 0 500 150" preserveAspectRatio="none" style={{ height: '100%', width: '100%' }}>
            <path d="M-0.00,49.85 C150.00,149.60 349.20,-49.85 500.00,49.85 L500.00,149.60 L-0.00,149.60 Z" style={{ stroke: 'none', fill: '#f4f9fd' }}></path>
          </svg>
        </div>
      )}

      <footer>
        <div className='footer-boxed'>
          <ul className="footer-links">
            <li>
              <a href={layoutT('claimant_charter_url')} target='_blank'>{layoutT('claimant_charter')}</a>
            </li>
            <li>
              <a href={layoutT('consumer_protection_url')} target='_blank'>{layoutT('consumer_protection')}</a>
            </li>
            <li>
              <a href={layoutT('declaration_of_accessibility_url')} target='_blank'>{layoutT('declaration_of_accessibility')}</a>
            </li>
            <li>
              <a href={layoutT('file_a_complaint_url')} target='_blank'>{layoutT('file_a_complaint')}</a>
            </li>
            <li><a href={layoutT('personal_information_protection_url')} target='_blank'>{layoutT('personal_information_protection')}</a>
            </li>
            <li>
              <a href={layoutT('terms_of_use_url')} target='_blank'>{layoutT('terms_of_use')}</a>
            </li>
            <li>
              <a href={layoutT('supplier_and_partner_services_url')} target='_blank'>{layoutT('supplier_and_partner_services')}</a>
            </li>
            <li>
              <a href={layoutT('assuris_member_url')} target='_blank'>{layoutT('assuris_member')}</a>
            </li>
          </ul>
          <div className="copyright">  © {new Date().getFullYear()} Humania Assurance inc. {layoutT('all_rights_reserved')}</div>
          {isDebugMode() && <div style={{ width: '100%', textAlign: 'center', fontSize: '10px', color: 'red' }}>v {packageJson.version}</div>
          }
        </div>
      </footer>

      <div dangerouslySetInnerHTML={{ __html: `<!-- ${packageJson.version} -->` }} /> 
    </>
  );
};

export default Layout;
